import React, {Component} from 'react';
import classnames from 'classnames';
import {SVGIcon} from '@homeaway/react-svg';

import {getSuggestionDetails} from '../functions/suggestiondetails';
import {isListingIdSearch} from '../functions/destinationHelper';
import {Thumbnail} from './thumbnail';

export class ResultRow extends Component {
    getIconDom = (result, suggestionsDetails) => {
        const {showResultIcons} = this.props;
        const iconDOM = [];
        if (showResultIcons && !isListingIdSearch(result)) {
            iconDOM.push(
                <span
                    key={`result__icon__span-${result.uuid}`}
                    className="result__first-row"
                >
                    <SVGIcon
                        key={`result__icon-${result.uuid}`}
                        markup={suggestionsDetails.icon}
                        className="result__icon"
                    />
                </span>
            );
        }
        return iconDOM;
    };

    getTwoLineElementTitleDom = (term, reactKey, isRecentlyViewed) => {
        let [firstLine, secondLine] = term.split(',');
        secondLine = secondLine ? term.slice(firstLine.length + 1) : null;
        return (
            <span key={reactKey}>
                <span
                    className={classnames('result__char', {
                        highlighted: true,
                        'result__first-row': !isRecentlyViewed
                    })}
                    key={`${reactKey}-${firstLine}`}
                >
                    {firstLine}
                </span>
                {secondLine && (
                    <>
                        <br />
                        <span
                            className={classnames('result__char')}
                            key={`${reactKey}-${secondLine}`}
                        >
                            {secondLine}
                        </span>
                    </>
                )}
            </span>
        );
    };
    getHighlightedTitleDOM = (highlightedTerm, highlightMode, reactKey) => {
        const titleDOM = [];
        for (let i = 0; i < highlightedTerm.length; i++) {
            const highlighted = highlightedTerm[i].highlighted;
            const charClassName = classnames('result__char', {
                highlighted:
                    (highlighted && highlightMode === 'match') ||
                    (!highlighted && highlightMode === 'non-match')
            });
            titleDOM.push(
                <span className={charClassName} key={`${reactKey}-${i}`}>
                    {highlightedTerm[i].value}
                </span>
            );
        }
        return titleDOM;
    };

    getTitleDom = (
        highlightedTerm,
        reactKey,
        term,
        isLIDSearch = false,
        isRecentlyViewed
    ) => {
        let {highlightMode} = this.props;
        const titleDOM = [];
        if (!isLIDSearch) {
            titleDOM.push(
                this.getTwoLineElementTitleDom(term, reactKey, isRecentlyViewed)
            );
        } else {
            this.getHighlightedTitleDOM(
                highlightedTerm,
                highlightMode,
                reactKey
            ).forEach((item) => {
                titleDOM.push(item);
            });
        }
        titleDOM.push('');
        return titleDOM;
    };

    addRecentlyViewed = (dom, result, reactKey) => {
        const {messages} = this.props;
        if (result.recentlyviewed) {
            dom.push(
                <span
                    className="recentlyviewed micro"
                    key={`${reactKey}-recentlyviewed`}
                >
                    {messages.recentlyviewed}
                </span>
            );
        }
    };

    addLabel = (dom, result, suggestionsDetails) => {
        const {showResultLabels, messages, poweredByGoogle} = this.props;
        if (
            suggestionsDetails.label &&
            showResultLabels &&
            (!poweredByGoogle || result.recentlyviewed)
        ) {
            dom.push(
                <span
                    key={`result__label-${result.uuid}`}
                    className="result__label hidden-xs small"
                >
                    {messages[suggestionsDetails.label]}
                </span>
            );
        }
    };

    renderListingContent = (
        shouldDisplayListingWithHeadline,
        resultCharsClassName,
        result,
        titleDOM
    ) => {
        let {
            listingProps: {headline = null, baseLocation = null, unitId = null}
        } = result;
        if (!shouldDisplayListingWithHeadline || headline === '') {
            headline = <br />;
        }
        return (
            <div>
                <div className={resultCharsClassName}>{headline}</div>
                <div className={resultCharsClassName}>
                    {titleDOM}
                    {unitId && (
                        <span className={classnames('listing__location')}>
                            {unitId}
                        </span>
                    )}
                    {baseLocation && (
                        <span className={classnames('listing__location')}>
                            {baseLocation}
                        </span>
                    )}
                </div>
            </div>
        );
    };

    /* eslint-disable complexity */
    displayTerm = (result) => {
        const {truncateResultTerms} = this.props;
        const dom = [];
        const reactKey = `searchresults-${result.uuid}-span`;
        const isLIDSearch = isListingIdSearch(result);
        const suggestionsDetails = getSuggestionDetails(
            result.type,
            isLIDSearch
        );
        const iconDOM = this.getIconDom(result, suggestionsDetails);
        const {highlightedTerm, term} = result;
        const isRecentlyViewed = result.recentlyviewed;
        let titleDOM = this.getTitleDom(
            highlightedTerm,
            reactKey,
            term,
            isLIDSearch,
            isRecentlyViewed
        );
        this.addRecentlyViewed(dom, result, reactKey);
        // show type labels for destinations except Google failover destinations
        this.addLabel(dom, result, suggestionsDetails);
        const resultCharsClassName = classnames('result__chars', {
            'result__chars--truncate-term': truncateResultTerms
        });

        const listingIcon =
            isLIDSearch && result && result.listingProps
                ? [
                      <span
                          className={classnames('result__listing-thumbnail')}
                          key={`result-thumbnail-${reactKey}`}
                      >
                          <Thumbnail
                              thumbnailUrl={result.listingProps.thumbnailUrl}
                          />
                      </span>
                  ]
                : [];
        const shouldDisplayListingWithHeadline =
            listingIcon.length && result.listingProps.headline;
        return [
            ...iconDOM,
            ...listingIcon,
            <span
                className={resultCharsClassName}
                key={`result-chars-${reactKey}`}
            >
                {!isLIDSearch
                    ? titleDOM
                    : this.renderListingContent(
                          shouldDisplayListingWithHeadline,
                          resultCharsClassName,
                          result,
                          titleDOM
                      )}
            </span>,
            ...dom
        ];
    };

    renderResultRow = (attributes, selected, style, title) => {
        const className = classnames(
            attributes.className || '',
            'result--two-line-display'
        );
        const attr = {...attributes, className};
        return (
            <div tabIndex="-1" {...attr}>
                <div className="result__bg bg-brand" />

                <div
                    role="option"
                    aria-selected={selected}
                    tabIndex="-1"
                    className="result__content"
                    style={style}
                >
                    {title}
                </div>
            </div>
        );
    };

    showTrendingHeading = (inputHasIcon) => {
        const {messages} = this.props;

        return (
            <div
                className={classnames(
                    'trending-destinations-heading',
                    'small',
                    {
                        'heading__has-input-icon': inputHasIcon
                    }
                )}
            >
                {messages.trendingdestinations}
            </div>
        );
    };

    getResultClassesForIcons({
        showResultIcons,
        inputHasIcon,
        isLIDSearch = false
    }) {
        const toPrefix = (bool) => (bool ? 'has' : 'no');

        return classnames({
            [`result--${toPrefix(showResultIcons)}-icon-${toPrefix(
                inputHasIcon
            )}-input-icon`]: !isLIDSearch
        });
    }

    render() {
        const {
            index,
            hasSelectedIndex,
            isMobile,
            last,
            result,
            selected,
            showResultIcons,
            inputHasIcon,
            hasTrendingHeading
        } = this.props;

        let classNames = {
            result: true,
            in: true,
            'has-selected-index': hasSelectedIndex,
            'recent-search__result': result.recentlyviewed,
            last,
            mobile: isMobile,
            desktop: !isMobile
        };
        const style = {};

        const suggestionDOM = this.displayTerm(result);

        const attributes = {
            ['data-suggestion-key']: index,
            ['key']: `searchresults-div-${index}-result`
        };

        const isLIDSearch = isListingIdSearch(result);
        const resultAttributes = {
            ...attributes,
            ['className']: classnames(
                {selected},
                classNames,
                this.getResultClassesForIcons({
                    showResultIcons,
                    inputHasIcon,
                    isLIDSearch
                })
            )
        };
        let trendingHeading = null;
        if (hasTrendingHeading) {
            trendingHeading = this.showTrendingHeading(inputHasIcon);
        }

        return (
            <React.Fragment>
                {trendingHeading}
                {this.renderResultRow(
                    resultAttributes,
                    selected,
                    style,
                    suggestionDOM
                )}
            </React.Fragment>
        );
    }
}
